"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.LanguageContext = void 0;
var React = require("react");
var provider_1 = require("@bootstrap-styled/provider");
var Router_1 = require("./Router");
var SignInStyle_1 = require("./SignInStyle");
var react_intl_1 = require("react-intl");
var utils_1 = require("../lang/utils");
var English_1 = require("../lang/English");
var Hindi_1 = require("../lang/Hindi");
var Gujarati_1 = require("../lang/Gujarati");
var createDefaultLanguage = function () { return ({
    language: 'en',
    setLanguage: function () { },
    message: {},
    setMessage: function () { }
}); };
exports.LanguageContext = React.createContext(createDefaultLanguage());
var App = function (props) {
    var _a = React.useState('en'), language = _a[0], setLanguage = _a[1];
    var _b = React.useState(utils_1.flattenMessages(English_1.default)), message = _b[0], setMessage = _b[1];
    var setGlobalLanguage = function (language) {
        setLanguage(language);
    };
    var setMessages = function (language) {
        var message = {};
        if (language === 'en') {
            message = utils_1.flattenMessages(English_1.default);
        }
        else if (language === 'gu') {
            message = utils_1.flattenMessages(Gujarati_1.default);
        }
        else {
            message = utils_1.flattenMessages(Hindi_1.default);
        }
        setMessage(message);
    };
    return (React.createElement("div", { className: "App" },
        React.createElement(exports.LanguageContext.Provider, { value: {
                language: language,
                setLanguage: setGlobalLanguage,
                message: message,
                setMessage: setMessages
            } },
            React.createElement(react_intl_1.IntlProvider, { locale: language, messages: message },
                React.createElement(provider_1.default, { theme: SignInStyle_1.LightTheme },
                    React.createElement(Router_1.default, __assign({ locale: language, message: message, setMessages: setMessages }, props)))))));
};
exports.default = App;
//# sourceMappingURL=App.js.map